// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1dUPb","form":"styles_form__2A6YV"};